export default __webpack_public_path__ + "static/media/booking-successful.1b9d59d3.svg";